import { VerticalTab } from '../../../shared/components/tabs/vertical-tabs/vertical-tabs.component';

export const MY_ACCOUNT_GENERAL_TABS: VerticalTab[] = [
  {
    name: 'Help & Support',
    icon: 'icon-question-circle-outline',
    routerLink: '/my-account/general/help-support'
  },
  {
    name: 'Privacy Policy',
    icon: 'icon-shield-check-outline',
    routerLink: '/my-account/general/privacy-policy'
  },
  {
    name: 'Terms & Conditions',
    icon: 'icon-form-outline',
    routerLink: '/my-account/general/terms-conditions'
  },
  {
    name: 'Delete My Account',
    icon: 'icon-trash-cancel-outline',
    routerLink: '/my-account/general/delete-my-account'
  }
];
